import type { AgentInfo, AgentModel } from './types';

const VENDORS: Record<string, string> = {
  anthropic: 'Anthropic',
  openai: 'OpenAI',
  ollama: 'Ollama',
};

const vendorName = (vendor: string): string =>
  Object.prototype.hasOwnProperty.call(VENDORS, vendor)
    ? VENDORS[vendor]
    : vendor;

/** "claude-opus-5-5 · Anthropic · claude_api", or the code-agent line. */
export const modelLine = (model: AgentModel | null): string =>
  model
    ? `${model.model} · ${vendorName(model.vendor)} · ${model.provider}`
    : 'Code, no model';

export const tagText = (tag: string | null): string => (tag ? `@${tag}` : '');

export type MemoryState = {
  kind: 'preferences' | 'off' | 'case_notes';
  text: string;
};

export const memoryState = (agent: AgentInfo): MemoryState => {
  const { preferences, caseNotes, note } = agent.memory;
  if (preferences) return { kind: 'preferences', text: note };
  if (caseNotes) return { kind: 'case_notes', text: note };
  return { kind: 'off', text: note };
};

/** What the memory list shows: the list (and its empty text) only once loaded. */
export const memoryListState = (
  memory: { status: 'loading' | 'ready' | 'error' } | undefined,
): 'loading' | 'list' | 'error' =>
  !memory || memory.status === 'loading'
    ? 'loading'
    : memory.status === 'error'
      ? 'error'
      : 'list';
